module.exports = __webpack_public_path__ + "img/src/components/ListGridCoverPhoto/medium_no_image.png?5cc960d0";